export default __webpack_public_path__ + "static/media/icon_swim.8ab049d5.svg";